import { onBeforeUnmount, onMounted, ref } from 'vue';

const readViewportClientSize = (): {
	clientWidth: number;
	clientHeight: number;
} => {
	if (typeof document === 'undefined') {
		return { clientWidth: 0, clientHeight: 0 };
	}
	const element = document.documentElement;
	return {
		clientWidth: element.clientWidth,
		clientHeight: element.clientHeight,
	};
};

export const useWindowSize = () => {
	const clientWidth = ref(0);
	const clientHeight = ref(0);

	const update = () => {
		const next = readViewportClientSize();
		clientWidth.value = next.clientWidth;
		clientHeight.value = next.clientHeight;
	};

	onMounted(() => {
		update();
		window.addEventListener('resize', update, { passive: true });
	});

	onBeforeUnmount(() => {
		window.removeEventListener('resize', update);
	});

	return { clientWidth, clientHeight };
};
